export const KPMGDataProvisionUsagePurpose = () => {
  return (
    <>
      前号に定める第三者が契約者との間で締結した契約に基づき契約者に対して提供する業務（監査業務及びアドバイザリー業務を含むが、これらに限られない。）遂行のために、契約者の口座情報を調査・分析等を行うため
    </>
  );
};
